import Vue from "vue/dist/vue.esm.js"
import Top from '../components/top.vue'

new Vue({
  el: '#top',
  components: { Top },
})